/* Atelier — Plate I: pins on the watercolor plate and the figure buttons select a figure and show its note. */
if (!customElements.get('atelier-plate')) {
  customElements.define(
    'atelier-plate',
    class AtelierPlate extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-index]');
          if (!button || !this.contains(button)) return;
          this.pick(parseInt(button.dataset.index, 10));
        });
        // the figure label and note keep the height of the longest one, so picking a figure never moves the page
        this.reserve = this.reserve.bind(this);
        this.reserve();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.reserve);
        let timer;
        window.addEventListener('resize', () => {
          clearTimeout(timer);
          timer = setTimeout(this.reserve, 150);
        });
        // Theme editor: show the figure whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const pin = event.target.closest && event.target.closest('.at-plate__pin');
          if (pin) this.pick(parseInt(pin.dataset.index, 10));
        });
      }

      reserve() {
        const fig = this.querySelector('.at-plate__fig');
        const pins = Array.from(this.querySelectorAll('.at-plate__pin'));
        if (!fig || pins.length < 2) return;
        const current = Math.max(0, Array.from(this.querySelectorAll('[data-index][aria-pressed="true"]')).map((b) => parseInt(b.dataset.index, 10))[0] || 0);
        const live = fig.getAttribute('aria-live');
        fig.removeAttribute('aria-live'); // measuring swaps the text; don't announce it
        fig.style.minHeight = '';
        let tallest = 0;
        pins.forEach((pin, i) => {
          this.pick(i, true);
          tallest = Math.max(tallest, fig.offsetHeight);
        });
        this.pick(current, true);
        fig.style.minHeight = `${tallest}px`;
        if (live) fig.setAttribute('aria-live', live);
      }

      pick(index, quiet) {
        const pins = Array.from(this.querySelectorAll('.at-plate__pin'));
        const pin = pins[index];
        if (!pin) return;
        this.querySelectorAll('[data-index]').forEach((button) => {
          button.setAttribute('aria-pressed', parseInt(button.dataset.index, 10) === index ? 'true' : 'false');
        });
        const format = this.dataset.figFormat || 'Fig. [n] · [title]';
        const label = this.querySelector('[data-fig-label]');
        if (label) label.textContent = format.replace('[n]', index + 1).replace('[title]', pin.dataset.title || '');
        const note = this.querySelector('[data-fig-note]');
        if (note) note.textContent = pin.dataset.note || '';
        const noteMobile = this.querySelector('[data-fig-note-mobile]');
        if (noteMobile) noteMobile.textContent = pin.dataset.noteMobile || pin.dataset.note || '';
      }
    }
  );
}
